module.exports = __webpack_public_path__ + "media/brands/scanclimber-0314f5af.png";